import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/api.service';
import { Router } from '@angular/router';
import { MYEVENTS } from 'src/app/config';

@Component({
    selector: 'app-event-history',
    templateUrl: './event-history.component.html',
    styleUrls: ['./event-history.component.css'],
    
})
export class EventHistoryComponent implements OnInit {
  uid: any;
  event: [];
  loader:boolean;
  page:boolean;
  constructor(private api: ApiService,private router:Router) {

    this.uid = this.api.getUserInfo();
    this.uid = this.uid['id'];
    this.api.Get(MYEVENTS + '/' + this.uid).then(data => {
      this.page=true;
      this.loader=false;
      this.event = data['data']['data'];
    }).catch(d=>{
      if( d.status == 503){
        this.api.onFail('Your session is expired please login again','Login');
        this.api.setGoto();
        this.api.setlogin(0);
        this.api.logout();
        setTimeout(() => {
        this.router.navigate(['/login']);
        },1000);
      } else{console.log(d)}
    });
  }

  detail(value) {
    this.router.navigate(['/event', value.id]);
  }
  ngOnInit(): void {
    this.loader=true;
    this.page=false;
  }

}
